import React, { useEffect } from "react";
import { motion } from "framer-motion";
import bgImg from '../Images/testimonials.webp'
import Breadcrumb from "../Components/Breadcrumb";
import { testimonials } from "../Data";
import Cta from "../Components/Cta";
import TestimonialsPageSchema from "../Schema/TestimonialPageSchema";
import ReviewSchema from "../Schema/ReviewSchema";
import BreadcrumbSchema from "../Schema/BreadcrumbSchema";
import MedicalClinicSchema from '../Schema/MedicalClinicSchema'
import GoogleReviews from "../Components/GoogleReviews";

const Testimonials=()=>{
     useEffect(() => {
            document.title =
              "Patient Reviews & Testimonials | Dr. Jigar Gor Ayurvedic Clinic";
        
            const metaDesc = document.querySelector("meta[name='description']");
            if (metaDesc) {
              metaDesc.setAttribute(
                "content",
                "Read real patient success stories and testimonials for Dr. Jigar Gor in Bhuj, Kutch. Discover how our authentic Ayurvedic & Panchakarma treatments heal lives."
              );
            }
        
            const canonical = document.querySelector("link[rel='canonical']");
          if (canonical) {
            canonical.setAttribute("href", "https://msayurved.com/testimonials");
          }
        
          const ogTitle = document.querySelector("meta[property='og:title']");
          if (ogTitle) {
            ogTitle.setAttribute(
              "content",
              "Patient Reviews & Testimonials | Dr. Jigar Gor Ayurvedic Clinic"
            );
          }
        
            const ogDesc = document.querySelector("meta[property='og:description']");
          if (ogDesc) {
            ogDesc.setAttribute(
              "content",
              "Read real patient success stories and testimonials for Dr. Jigar Gor in Bhuj, Kutch. Discover how our authentic Ayurvedic & Panchakarma treatments heal lives."
            );
          }
        
          const ogUrl = document.querySelector("meta[property='og:url']");
          if (ogUrl) {
            ogUrl.setAttribute("content", "https://msayurved.com/testimonials");
          }
        
            const ogImage = document.querySelector("meta[property='og:image']");
          if (ogImage) {
            ogImage.setAttribute(
              "content",
              "https://msayurved.com/Images/testimonials.webp"
            );
          }
        
            const twitterTitle = document.querySelector("meta[name='twitter:title']");
          if (twitterTitle) {
            twitterTitle.setAttribute(
              "content",
              "Patient Reviews & Testimonials | Dr. Jigar Gor Ayurvedic Clinic"
            );
          }
        
            const twitterDesc = document.querySelector(
            "meta[name='twitter:description']"
          );
          if (twitterDesc) {
            twitterDesc.setAttribute(
              "content",
              "Read real patient success stories and testimonials for Dr. Jigar Gor in Bhuj, Kutch. Discover how our authentic Ayurvedic & Panchakarma treatments heal lives."
            );
          }
        
            const twitterImage = document.querySelector("meta[name='twitter:image']");
          if (twitterImage) {
            twitterImage.setAttribute(
              "content",
              "https://msayurved.com/Images/testimonials.webp"
            );
          }
          }, []);

    const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.2,
      ease: "easeOut",
    },
  },
};

const gridVariant = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2,
    },
  },
};

const breadcrumbItems = [
    {
      name: "Home",
      url: "https://msayurved.com/"
    },
    {
      name: "Testimonials",
      url: "https://msayurved.com/testimonials"
    },
  ];
    return(
        <>

    <TestimonialsPageSchema />
    <MedicalClinicSchema />
  <ReviewSchema testimonials={testimonials} />
  <BreadcrumbSchema items={breadcrumbItems} />

         {/**BREADCRUMB SECTION */}
        <Breadcrumb
        title="Testimonials"
        bgImage={bgImg}
        />

        {/**TESTIMONIALS GRID */}
         <section className="testimonials-section testimonials-pg">
      <div className="container hero-container">
        <motion.p
          className="section-subheading"
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.2,
          }}
          variants={fadeUp}
        >
          Testimonials
        </motion.p>

        <motion.h2
          className="section-heading"
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.2,
          }}
          variants={fadeUp}
        >
          Words from Our Happy Patients
        </motion.h2>

      <motion.div className="testimonials-main-grid" variants={gridVariant}>
  <GoogleReviews layout="grid" limit={12} />
</motion.div>


      </div>
    </section>

    <div style={{marginBottom:"80px"}}></div>

    {/**CTA */}
    <Cta />

        </>
    )
}
export default Testimonials;